// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3P02b","controls":"styles_controls__20sFs","charLimit":"styles_charLimit__3oJUP","input":"styles_input__2Mqjd","send":"styles_send__4aL5A"};